import { useMutation, useQueryClient } from "@tanstack/react-query";
import { banSubDealer, unbanSubDealer } from "@/api/subDealers";
import { SubDealersQueryKeys } from "@/tanstackQuery/queries";

export const useBanSubDealer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: banSubDealer,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [SubDealersQueryKeys.All],
      });
    },
  });
};

export const useUnbanSubDealer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unbanSubDealer,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [SubDealersQueryKeys.All],
      });
    },
  });
};
